module.exports = __webpack_public_path__ + "static/media/muli-latin-200.b79246db.woff";